import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "See how the sound reduction index of a monolithic concrete wall is reduced when a window and a door are added into it, thus turning it into a composite wall structure. Its sound reduction index can be calculated using the values of the sound reduction index of individual elements and their surface areas. The same procedure can be applied to the single-number values of the weighted sound reduction index",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Conrete wall" }, { name: "Wall with window" }, { name: "Wall with window and door" }],
        },
      ],
      extraContent: [[], [], []],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/17/principle/conrete-wall.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/17/principle/wall-with-window.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/17/principle/wall-with-window-and-door.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
